export default __webpack_public_path__ + "static/media/uicons-regular-rounded.632ccfc4.woff2";